import classNames from 'classnames';
import { func, node, object, string } from 'prop-types';

import { ImageLoader } from '~/components/Image';

import defaultBackground from '~/assets/images/loot-cards/background.png';
import defaultPlatform from '~/assets/images/loot-cards/platform_placeholder.png';

import style from './LootCard.module.scss';

/**
 *
 * @param rating {number}
 * @return {('frameGold'|'frameWhite'|'framePurple'|'frameRed'|'frameGreen'|'frameBlue')}
 */
const getFrameClassFromRating = (rating) => {
  if (rating >= 9) {
    return 'frameGold';
  }
  if (rating === 8) {
    return 'frameWhite';
  }
  if (rating === 7) {
    return 'framePurple';
  }
  if (rating >= 5) {
    return 'frameRed';
  }
  if (rating >= 3) {
    return 'frameGreen';
  }
  return 'frameBlue';
};

const CardTemplateView = ({ cardTemplate, onClick, children, className }) => {
  if (!cardTemplate) {
    return null;
  }

  const { rating, platforms = [] } = cardTemplate;
  const platformLabel = platforms[0];

  const frame = getFrameClassFromRating(rating);

  return (
    <div
      className={classNames(style.cardTemplate, frame, className)}
      onClick={onClick}
    >
      <ImageLoader
        className={style.platformLabel}
        alt="Platform label"
        path={platformLabel?.image}
        src={defaultPlatform}
      />
      <ImageLoader
        path={cardTemplate.image}
        src={defaultBackground}
        loadingPlaceholder={defaultBackground}
        className={style.cardImage}
        placeholderClassName={style.cardPlaceholder}
        alt="Card"
      />
      {children}
    </div>
  );
};

CardTemplateView.propTypes = {
  cardTemplate: object.isRequired,
  onClick: func,
  children: node,
  className: string,
};

export default CardTemplateView;
